const s = {
  base: {
    minWidth: 4,
    height: 4,
    pt: (e) => e.spacing(0.25)
  },
  secondary: {
    bg: "primary"
  }
}, a = {
  badges: s
};
export {
  a as badgesTheme
};
